// src/pages/purchase-requisition/components/ApproveConfirmDialog.jsx
import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button
} from "@mui/material";

function ApproveConfirmDialog({ open, onClose, onConfirm }) {
    return (
        <Dialog open={open} onClose={onClose} aria-labelledby="approve-dialog-title">
            <DialogTitle id="approve-dialog-title">Konfirmasi Persetujuan</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Apakah Anda yakin ingin menyetujui order ini?
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ pt: "20px", pb: "20px", pl: "24px", pr: "24px" }}>
                <Button onClick={onClose}>Batal</Button>
                <Button onClick={onConfirm} variant="contained" color="success">
                    Setujui
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ApproveConfirmDialog;
